import React from 'react';
import styled from 'styled-components/macro';
import MarkupRenderer from 'components/MarkupRenderer/MarkupRenderer';
import useTranslate from 'hooks/useTranslate';
import Inner from 'components/Inner/Inner';
import Breakpoints from 'themes/constants/breakpoints';
import Loader from 'components/Loader/Loader';

const ErrorContainer = styled(Inner)`
    display: flex;
    flex-flow: column nowrap;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    ${({ theme }) => theme.paddings.wrap.mobile};
    * {
        margin-bottom: 20px;
        font-size: 20px;
        font-weight: 700;
        text-align: center;
    }
    @media only screen and (${Breakpoints.TABLET}) {
        ${({ theme }) => theme.paddings.wrap.tablet};
    }
    @media only screen and (${Breakpoints.LAPTOP}) {
        ${({ theme }) => theme.paddings.wrap.desktop};
    }
`;
const ErrorTitle = styled.h4``;
const ErrorData = styled(MarkupRenderer)``;

interface IErrorProps {
  title?: string[] | string | null
  data?: string | null
  isLoading?: boolean
}

function Error(props: IErrorProps) {
  const {
    title,
    data,
    isLoading,
  } = props;

  const [getText] = useTranslate();

  if (isLoading) return <Loader />;
  return (
    <ErrorContainer withPaddings>
      {title ? (
        <ErrorTitle>{getText(title)}</ErrorTitle>
      ) : null}
      {data ? (
        <ErrorData markup={data} type="p" />
      ) : null}
    </ErrorContainer>
  );
}

export default Error;
